import { useMemo } from 'react'

import PageContext from '@contexts/pageContext'

import useNumericParams from '@hooks/useNumericParams'

import PageContent from './components/PageContent'

const Relations = () => {
  const { priceListId } = useNumericParams()

  const pageContext = useMemo(() => ({}), [])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent priceListId={priceListId} />
    </PageContext.Provider>
  )
}

export default Relations
